export const SET_SHOW_INFOPOPUP = "SET_SHOW_INFOPOPUP"